module.exports = __webpack_public_path__ + "static/media/creditcardbenefits-2.ce51c1dc.svg";